module.exports = __webpack_public_path__ + "media/images/pic/map-65c1fc866ac1230c5d73d77f7832711f.png";